import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function ProtectedRoute({ role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-[#C86B53] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) {
    const loginPath = role === "admin" ? "/admin/login" : role === "salesperson" ? "/sales/login" : "/login";
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }
  if (role && user.role !== role) {
    const roleHome = user.role === "admin" ? "/admin" : user.role === "salesperson" ? "/sales" : "/dashboard";
    return <Navigate to={roleHome} replace />;
  }
  return <Outlet />;
}
